import { render, staticRenderFns } from "./WomensBrunch.vue?vue&type=template&id=a4f6edd0&"
import script from "./WomensBrunch.vue?vue&type=script&lang=js&"
export * from "./WomensBrunch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports